import { useContext } from 'react'
import { DashboardContext } from '@/context/DashboardContext'

export interface OfferReset {
  /** ISO instant of the next reset for the offer on screen, or null when unknown. */
  nextReset: string | null
  /** IANA zone that reset happens in, or null when unknown. */
  zone: string | null
  /** The offer-local hour (0-23) its day starts at, or null when unknown. */
  hour: number | null
}

/**
 * The reset instant of the offer currently on screen.
 *
 * Each offer rolls over at 00:00 in its OWN timezone (cap-api `offers.reset_timezone`) —
 * Reco at midnight Pacific, everything else at midnight UTC — so a countdown computed as
 * "next midnight UTC" is wrong on the Reco tab. `overflow_window` in the dashboard payload
 * carries the server's answer per offer; this reads it.
 *
 * Deliberately tolerant of being called OUTSIDE `DashboardProvider`: the header renders on
 * the admin routes too, where no offer is selected. There it returns nulls and callers fall
 * back to midnight UTC, which is the right answer for a network-wide view.
 */
export function useOfferReset(): OfferReset {
  const ctx = useContext(DashboardContext)
  const win = ctx?.overflowWindow ?? null
  return {
    nextReset: win?.resets_at_utc ?? null,
    zone: win?.reset_timezone ?? null,
    hour: win?.reset_hour ?? null,
  }
}
